module.exports = __webpack_public_path__ + "static/assets/d3cdd105293785bafc302d53039d5001.gif";